//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {parser} from "@/utils/parser";

export default {
  name: "SectionEntityGrid",
  components: {
    Scroller: () => import("@/components/common/Scroller"),
    EmptyEntityCardsSlider: () => import("@/components/common/EmptyEntityCardsSlider"),
    EventCard: () => import("@/components/common/EventCard"),
    NewsCard: () => import("@/components/common/NewsCard"),
    PlaceCard: () => import("@/components/common/PlaceCard"),
    EmptyEntityCard: () => import("@/components/common/EmptyEntityCard"),
    RouteCard: () => import("@/components/common/RouteCard/index"),
    ExcursionCard: () => import("@/components/common/ExcursionCard/index"),
    Section: () => import("@/components/common/Section")
  },
  props: {
    title: {
      type: String,
      default: () => ""
    },
    entity: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      items: [],
      pending: true,
      show: true,
    };
  },
  computed: {
    link() {
      return `/${this.entity}?city_id=${this?.params?.city_id}`
    },
    card() {
      switch (this.entity) {
        case "events": {
          return "EventCard";
        }
        case "excursions": {
          return "ExcursionCard";
        }
        case "routes": {
          return "RouteCard";
        }
        case "places": {
          return "PlaceCard";
        }
        case "news": {
          return "NewsCard";
        }
        default: {
          return "EmptyCard";
        }
      }
    },
    gap() {
      return this.$mediaSwitch({hd: 32, sm: 8, defaultValue: 24});
    },
    columns() {
      return this.$mediaSwitch({md: 2, sm: 1, defaultValue: 3});
    }
  },
  mounted() {
    this.$axios.$get(`/api/${this.entity}?${parser({
      params: {
        lang: this.$i18n.locale,
        count: 3,
        resolution: "micro",
        ...this.params
      }
    })}`)
      .then(response => {
        this.items = response.data || [];
        if (this.items?.length < 1) {
          this.show = false;
        }
      })
      .catch((error) => {
        if (error && error.response) {
          throw new Error(`${error?.response?.status}, ${error?.response?.data?.message}`);
        }
        this.show = false;
      })
      .finally(() => this.pending = false);
  }
};
